(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-collection-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ss-format-link]');
    if (!link) return;
    const url = new URL(link.href);
    const current = new URLSearchParams(window.location.search);
    current.delete('page');
    current.delete('section_id');
    current.delete('sections');
    url.search = current.toString();
    link.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-project-inquiry"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(){
    const root=document.getElementById('ss-project-inquiry');if(!root||root.dataset.ready)return;root.dataset.ready='true';
    const data=JSON.parse(root.querySelector('.ss-inquiry-data').textContent),details=root.querySelector('.ss-inquiry-details');
    const app=document.querySelector('[id$="__'+root.dataset.appSection+'"]');if(!app)return;app.classList.add('ss-inquiry-app');app.hidden=true;
    const status=root.querySelector('.ss-inquiry-status'),drafts={};let current=null;
    const marker=globalThis.SSUiText('\n--- Weitere Angaben ---\n');
    function remember(){if(!current)return;drafts[current.key]=[...root.querySelectorAll('[data-topic-field]')].map(e=>e.value);}
    function updateMessage(){
      if(!current)return false;const text=app.querySelector('textarea[name="textarea"]');if(!text)return false;
      const project=app.querySelector('input[name="text-2"]');
      if(project){project.readOnly=true;if(project.value!==current.title){Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set.call(project,current.title);project.dispatchEvent(new Event('input',{bubbles:true}));project.dispatchEvent(new Event('change',{bubbles:true}));}}
      const old=text.value,free=old.includes(marker)?old.slice(old.indexOf(marker)+marker.length):old;
      const rows=[globalThis.SSUiText('Projektanfrage: ')+current.title];
      for(const e of root.querySelectorAll('[data-field],[data-topic-field]'))rows.push(globalThis.SSUiText(e.dataset.field||e.dataset.label)+': '+(e.value.trim()||globalThis.SSUiText('Noch offen')));
      const next=rows.join('\n')+marker+free;
      if(text.value!==next){Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype,'value').set.call(text,next);text.dispatchEvent(new Event('input',{bubbles:true}));text.dispatchEvent(new Event('change',{bubbles:true}));}
      const heading=app.querySelector('.globo-heading'),headingText=current.title+globalThis.SSUiText(' – deine Kontaktdaten');if(heading&&heading.textContent!==headingText)heading.textContent=headingText;
      return true;
    }
    function select(key,scroll){
      const item=data.find(x=>x.key===key);if(!item)return;remember();current=item;details.hidden=false;app.hidden=false;root.classList.add('is-selected');
      for(const button of root.querySelectorAll('[data-project]'))button.setAttribute('aria-pressed',String(button.dataset.project===key));
      root.querySelector('#ss-inquiry-title').textContent=item.title+globalThis.SSUiText(' anfragen');root.querySelector('#ss-inquiry-description').textContent=item.description;
      root.querySelector('#ss-inquiry-subject').textContent=globalThis.SSUiText('Projektanfrage: ')+item.title;
      const labels=item.fields.split('\n');root.querySelectorAll('[data-topic-field]').forEach((e,i)=>{const parts=(labels[i]||globalThis.SSUiText('Weitere Details')).split('|');e.dataset.label=parts[0];e.closest('label').querySelector('span').textContent=parts[0];e.placeholder=parts[1]||'';e.value=drafts[key]?.[i]||''});
      const url=new URL(location.href);url.searchParams.set('projekt',key);history.replaceState(null,'',url);document.title=item.title+globalThis.SSUiText(' anfragen | Schneider Solutions');
      updateMessage();if(scroll){details.scrollIntoView({behavior:'instant',block:'start'});root.querySelector('#ss-inquiry-title').focus({preventScroll:true});}
    }
    root.querySelectorAll('[data-project]').forEach(b=>b.addEventListener('click',()=>select(b.dataset.project,true)));
    root.querySelector('.ss-inquiry-change').addEventListener('click',()=>{root.classList.remove('is-selected');root.querySelector('.ss-inquiry-options').scrollIntoView({behavior:'smooth',block:'start'});root.querySelector('[data-project]')?.focus({preventScroll:true});});
    root.querySelector('.ss-inquiry-continue').addEventListener('click',()=>{if(updateMessage()){status.textContent=globalThis.SSUiText('Deine Projektangaben wurden in die Anfrage übernommen.');app.scrollIntoView({behavior:'instant',block:'start'});app.querySelector('input[name="text-1"]')?.focus({preventScroll:true});}else{status.textContent=globalThis.SSUiText('Das Kontaktformular wird noch geladen. Bitte versuche es gleich erneut oder schreibe uns an help@schneider-solutions.store.');}});
    root.querySelectorAll('input,select').forEach(e=>e.addEventListener('change',updateMessage));
    app.addEventListener('click',e=>{if(e.target.closest('button'))updateMessage();},true);
    app.addEventListener('submit',()=>updateMessage(),true);
    const initial=new URLSearchParams(location.search).get('projekt');if(initial)select(initial,false);
    const observer=new MutationObserver(()=>{updateMessage();});observer.observe(app,{childList:true,subtree:true});
    updateMessage();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-service-navigation"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ss-service-navigation')) {
  customElements.define('ss-service-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const start = () => {
        this.navigation = this.querySelector('.ss-launch__nav');
        if (!this.navigation || !this.hasAttribute('data-sticky')) return;
        this.header = document.querySelector('sticky-header');
        this.update = () => {
          const headerBounds = this.header?.getBoundingClientRect();
          const offset = headerBounds && headerBounds.top <= 40 && headerBounds.bottom > 0 ? headerBounds.bottom : 0;
          this.style.setProperty('--ss-header-offset', `${offset}px`);
          this.style.setProperty('--ss-nav-height', `${this.navigation.getBoundingClientRect().height}px`);
          this.toggleAttribute('data-fixed', window.innerWidth > 749 && this.getBoundingClientRect().top <= offset);
        };
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        window.addEventListener('scroll', this.schedule, { passive: true, signal: this.controller.signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal: this.controller.signal });
        this.header?.addEventListener('transitionend', this.schedule, { signal: this.controller.signal });
        this.update();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.controller.signal });
      else this.frame = requestAnimationFrame(() => { this.frame = null; start(); });
    }
    disconnectedCallback() { this.controller?.abort(); if (this.frame) cancelAnimationFrame(this.frame); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-announcementbar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var marquee = document.querySelector('.section-marquee-announcement[id^="announcement-"]');
    if (marquee) {
      document.documentElement.style.setProperty('--marquee-height', marquee.offsetHeight + 'px');
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
